import React, { FC } from 'react';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import TextModuleContainer from '../@shared/textModuleContainer';
import { TextModuleProps } from '../@shared/textModuleContainer/types/textModuleContainer.types';

const TextModule: FC<TextModuleProps> = (props) => {
  const {fields} = props;
  const title = fields?.title;
  return (
    <AnalyticsVisibleEvent rendering={props?.rendering} title={title?.value} template="Text Module">
      <TextModuleContainer {...(props)}/>
    </AnalyticsVisibleEvent>
  );
};

export default TextModule;
